module.exports = __webpack_public_path__ + "img/course.370d8ce7.png";